<template>
    <section class="container">
        <div class="row">
            <div class="col-md-2" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
            <adminSidenav></adminSidenav>
            </div>
            <div class="col">
                <div class="container">
                    <!-- <strong class="tit_category"><router-link :to="{name : 'notice'}" >Notice</router-link></strong>-->
                    <h2>공지사항</h2>
                    <hr/>
                    <div class="">
                        <h4 class="tit_post">{{notice.title}}</h4>
                    </div>
                    <div class="">
                    <span>{{notice.modifiedDate}}</span>
                    <span v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                        <button class="btn btn-outline-dark btn-sm" style="border-radius: 20px;">
                            <router-link :to="{name : 'noticeModified', params : { id : notice.id }}" style="color: black;">수정</router-link>
                        </button>
                        <button type="button" v-on:click="deleteCheck()"  class="btn btn-outline-dark btn-sm" style="border-radius: 20px;">삭제</button>
                    </span>
                    <span class="float-right">조회수 : {{notice.viewCount}}</span>
                    </div>

                    <hr/>

                    <div v-html="notice.content" style="margin-bottom: 100px;"/>

                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-if="next != null">
                            <button type="button" v-on:click="getNearArticles(next.id)" class="btn btn-white" >다음글 : {{next.title}}</button>
                        </li>
                        <li class="list-group-item" v-if="prev != null">
                            <button type="button" v-on:click="getNearArticles(prev.id)" class="btn btn-white" >이전글 : {{prev.title}}</button>
                        </li>
                    </ul>
                    <div class="row listmargin">
                        <div class="col text-center">
                            <button type="button" v-on:click="goList()" class="btn btn-dark" >목록으로</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import adminSidenav from '@/components/admin/Sidenav.vue'

    export default {
        name: 'NoticeShow',
        components: {adminSidenav},
        data() {
            return {
                notice : {},
                next : {},
                prev : {},
            }
        },
        methods: {
            deleteCheck() {
                this.popupToggle(`확인`, `이 공지를 삭제 하시겠습니까?`, this.deleteContents)
            },
            deleteContents() {
                let me = this;
                this.axios.delete(process.env.VUE_APP_NOTICE_API_URL + `/${me.$route.params.id}`)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('공지사항','삭제 되었습니다.');
                        me.goList();
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            getNearArticles(id) {
                let me = this;
                this.axios.get(process.env.VUE_APP_NOTICE_API_URL + `/near/${id}`)
                    .then(function (res) {
                        me.next = res.data.next;
                        me.prev = res.data.prev;
                        me.notice = res.data.now;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            goList() {
                this.$router.push({name:'notice'});
            },
            popupToggle(title, text, callback) {
                this.$modal.show('dialog', {
                    title: title,
                    text: text,
                    buttons: [
                        {
                            title: title,
                            handler: () => {
                                callback();
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '취소'
                        },
                    ]
                })
            },
        },
        mounted() {
            this.getNearArticles(this.$route.params.id)
        },
    }
</script>
<style>
    span {
        margin: 3px;
    }
    .listmargin {
        margin : 15px;
    }

</style>